import { FORM_ERROR } from 'final-form'
import { Component, Watch } from 'vue-property-decorator'

import { MovementTypes, ThesaurusTerm } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { fetch } from '@skinsoft/network'
import { MovementDataStore, ThesaurusTermDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

import { router, Routes } from '../../../router'
import { CreateMovementForm, Values } from './create-movement-form'

const MOTIVE_THESAURUS_ID = '5afe82242ab7912341617924'

@Component({
    components: {
        sCreateMovementForm: CreateMovementForm,
    },
    template: require('./create-movement-modal.html'),
})
export class CreateMovementModal extends ReactiveVue {
    public canBeClosed = false;
    public initialValues: Values = {
        motive: null as any,
        title: null as any,
    };
    public motives: ThesaurusTerm[] = null as any;
    public mounted = false;
    public $movementDataStore: MovementDataStore;
    public $thesaurusTermDataStore: ThesaurusTermDataStore;
    public thesaurusSelectors = thesaurusTermSelectors;
    public movementType;

    public $refs: {
        modal: any;
    };

    public open(movementType: MovementTypes) {
        this.movementType = movementType;
        (this.$refs.modal as any).show();
    }

    public onHide() {
        this.canBeClosed = false;
        this.mounted = false;
    }

    public onShow() {
        this.mounted = true;
    }

    public subscribeToMotiveThesaurus() {
        this.subscribeTo(
            this.$thesaurusTermDataStore.fetchRoot(MOTIVE_THESAURUS_ID),
            thesaurusTerms => {
                this.motives = thesaurusTerms;
            },
            'motiveThesaurus',
        );
    }

    public async onSubmit(values) {
        try {
            const { id } = await (this.$movementDataStore as MovementDataStore).createMovement(
                this.movementType,
                undefined,
                values.title,
                values.motive,
            );

            const params: Record<string, string> = { id };
            (this.$refs.modal as any).hide();
            return router.push({
                name: Routes.MOVEMENT,
                params,
            });
        } catch (error) {
            return {
                [FORM_ERROR]: fetch.isNetworkError(error)
                    ? 'entity.createModal.error.network'
                    : 'entity.createModal.error.api',
            };
        }
    }

    @Watch('mounted')
    private onMountedChange(value) {
        this.$emit('mounted', value);
        if (value) {
            this.unsubscribeFrom('motiveThesaurus');
            this.subscribeToMotiveThesaurus();
        }
    }
}
